import React, { Component } from 'react'
import { Header, Icon , Button, Divider, Modal, Form, TextArea} from 'semantic-ui-react'

export default class GeneratedLicenseReq extends Component {
    constructor(props) {
        super(props)
    }

    componentWillMount() {
        this.setState({
            canSave: false,
            open: false
        })

    }

    onClose = () => {
        this.setState({open: false})
    }

    onOpen = () => {
        this.setState({open: true})
        return this.props.getLicenseReq(this.props.rowId)
    }

    render() {
        const {licenseId, licenseReq} = this.props;
        const {open} = this.state;

        return (
            <Modal size='tiny' open={open} dimmer='inverted' trigger={<Icon name='info' size='large' onClick={this.onOpen}/>} >
                <Modal.Header>
                    <Header as='h4'>
                        <Icon.Group size='large'>
                            <Icon name='info'/>
                        </Icon.Group>
                        Registered license request
                    </Header>
                </Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Field>
                            <label>License id:</label>
                            <input value={licenseId} readOnly={true}/>
                        </Form.Field>

                        <Form.Field control={TextArea} label='License request:' value={licenseReq} rows={4} autoHeight style={{fontFamily: 'Monospace'}}/>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.onClose}>
                        <Icon name='user cancel' />Cancel
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}
